__webpack_public_path__ = (function () {
  const scripts = document.getElementsByTagName("script");
  let currentScript = "";
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].src;
    if (src && src.includes("/static/js")) {
      currentScript = src;
      break;
    } else {
      console.log("skipping script:", src);
    }
  }

  const newPath =
    currentScript.substring(0, currentScript.lastIndexOf("/static/js/")) + "/";

  console.log("first script path:", currentScript);
  console.log("setting source path:", newPath);
  return newPath;
})();
export {};
